import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  variant?: 'default' | 'glass' | 'solid';
}
export function Card({
  className = '',
  children,
  variant = 'default',
  ...props
}: CardProps) {
  const variants = {
    default: 'bg-slate-800/50 border border-slate-700/50 backdrop-blur-sm',
    glass: 'bg-white/5 border border-white/10 backdrop-blur-md',
    solid: 'bg-slate-800 border border-slate-700'
  };
  return <motion.div className={`rounded-xl overflow-hidden ${variants[variant]} ${className}`} {...props} data-id="element-234">
      {children}
    </motion.div>;
}